<div class="layout-column full-height availability-cell">

  <!-- On another project / conflict state -->
  <div *ngIf="computed.isOnAnotherProjectOnly"
       class="layout-column layout-align-start-start on-another-project-state">
    <div class="layout-row layout-align-start-center">
      <span translate>On another project</span>
      <bringoz-icon *ngIf="computed.hasConflict"
                    iconName="calendar-outline"
                    fill="var(--system-error, #f44336)"
                    classSize="sm"
                    class="margin-left-5 cursor-help"
                    [ngbTooltip]="'This agent already has a route published in another visit schedule' | translate"
                    openDelay="300"
                    container="body"
                    triggers="hover">
      </bringoz-icon>
    </div>
    <span *ngIf="computed.hasCurrentProjectConflict && computed.currentProjectConflictTerritories" class="text-ellipsis">{{ computed.currentProjectConflictTerritories }}</span>
    <span *ngIf="!computed.hasCurrentProjectConflict && computed.formattedOtherProjectTerritories" class="text-ellipsis">{{ computed.formattedOtherProjectTerritories }}</span>
    <span class="layout-row layout-align-start-center add-availability-link"
          (click)="onEditAvailability($event, true)">
      <bringoz-icon iconName="plus" classSize="sm" fill="#007bff"></bringoz-icon>
      <span translate>Add Availability</span>
    </span>
  </div>

  <!-- Conflict + valid availability carousel -->
  <div *ngIf="computed.hasMixedConflictState" class="layout-row layout-align-start-center availability-carousel">
    <span class="carousel-arrow" (click)="onCarouselPrev($event)">
      <bringoz-icon iconName="chevron-left" classSize="sm"></bringoz-icon>
    </span>

    <div class="flex layout-column layout-align-start-start carousel-content"
         [ngClass]="{
           'blue-time': computed.carouselIsAvailable && !computed.carouselIsConflictPage,
           'red-time': !computed.carouselIsAvailable && !computed.carouselIsConflictPage,
           'no-time-window': computed.carouselIsConflictPage
         }">
      <div class="layout-row layout-align-start-center">
        <span *ngIf="!computed.carouselIsConflictPage" class="text-ellipsis">{{ computed.carouselTimeWindow || ('No Time window' | translate) }}</span>
        <span *ngIf="computed.carouselIsConflictPage" translate>On another project</span>
        <bringoz-icon *ngIf="computed.carouselIsConflictPage"
                      iconName="calendar-outline"
                      fill="var(--system-error, #f44336)"
                      classSize="sm"
                      class="margin-left-5 cursor-help"
                      [ngbTooltip]="'This agent already has a route published in another visit schedule' | translate"
                      openDelay="300"
                      container="body"
                      triggers="hover">
        </bringoz-icon>
      </div>
      <span *ngIf="computed.carouselTerritories" class="text-ellipsis">{{ computed.carouselTerritories }}</span>
    </div>

    <bringoz-button type="tertiary"
                    theme="primary"
                    (onClick)="onEditAvailability($event, false, computed.carouselResources)">
      <bringoz-icon iconName="edit" classSize="lg"></bringoz-icon>
    </bringoz-button>

    <span class="carousel-arrow" (click)="onCarouselNext($event)">
      <bringoz-icon iconName="chevron-right" classSize="sm"></bringoz-icon>
    </span>
  </div>

  <!-- Time Window -->
  <div *ngIf="!computed.isOnAnotherProjectOnly && !computed.hasMixedConflictState" class="layout-row layout-align-start-center info-row">
    <div *ngIf="computed.hasTimeWindow"
         class="flex br-body-2 time-window layout-row layout-align-start-center"
         [ngClass]="{'blue-time': computed.isFirstResourceAvailable, 'red-time': !computed.isFirstResourceAvailable}">
      <span *ngIf="!availability?.timeWindow" translate>No Time window</span>

      <span *ngIf="availability?.timeWindow && !computed.hasMultipleInSameProject" class="text-ellipsis">
        {{availability.timeWindow | bringozTime: 'from'}} - {{availability.timeWindow | bringozTime: 'to'}}
      </span>
      <span *ngIf="availability?.timeWindow && computed.hasMultipleInSameProject" class="text-ellipsis">
        {{computed.displayedTimeWindow}}
      </span>

      <bringoz-icon *ngIf="computed.isCrossDateAvailability"
                    iconName="start-day"
                    classSize="sm"
                    class="margin-left-5 cursor-help cross-date-icon"
                    [ngbTooltip]="'Cross Days' | translate"
                    openDelay="300"
                    container="body"
                    triggers="hover">
      </bringoz-icon>

      <bringoz-icon *ngIf="computed.hasOtherProjectAvailability"
                    iconName="error-outline"
                    fill="var(--system-error, #f44336)"
                    classSize="sm"
                    class="margin-left-5 cursor-help"
                    [ngbTooltip]="otherProjectTooltip"
                    openDelay="300"
                    container="body"
                    triggers="hover">
        <ng-template #otherProjectTooltip>
          <div class="layout-column padding-5" style="text-align: center;">
            <div translate>Availability doesn't belong to</div>
            <div translate>current project</div>
            <div class="margin-top-5">
              <span class="font-weight-600">{{ computed.formattedOtherProjectTimes }}</span>
              <span *ngIf="computed.formattedOtherProjectTerritories" class="margin-left-5">{{ computed.formattedOtherProjectTerritories }}</span>
            </div>
          </div>
        </ng-template>
      </bringoz-icon>

      <bringoz-icon *ngIf="computed.hasConflict"
                    iconName="calendar-outline"
                    fill="var(--system-error, #f44336)"
                    classSize="sm"
                    class="margin-left-5 cursor-help"
                    [ngbTooltip]="'This agent already has a route published in another visit schedule' | translate"
                    openDelay="300"
                    container="body"
                    triggers="hover">
      </bringoz-icon>

      <span *ngIf="!computed.hasOtherProjectAvailability && computed.hasMultipleInSameProject"
            class="margin-left-5 font-weight-600 cursor-help"
            style="color:  #007bff"
            [ngbTooltip]="sameProjectTooltip"
            openDelay="300"
            container="body"
            triggers="hover">
        +{{computed.currentProjectResources.length - 1}}
        <ng-template #sameProjectTooltip>
          <div class="layout-column padding-5 text-left">
            <div *ngFor="let r of computed.currentProjectResources" class="margin-bottom-5">
              <span class="font-weight-600">{{ formatResourceTime(r) }}</span>
              <span class="margin-left-5" *ngIf="getResourceBranchesText(r)">({{ getResourceBranchesText(r) }})</span>
              <span class="margin-left-5"
                    [style.color]="r.disabled ? '#f44336' : '#4caf50'">
                 - {{ (r.disabled ? 'Unavailable' : 'Available') | translate }}
              </span>
            </div>
          </div>
        </ng-template>
      </span>
    </div>
    <div *ngIf="!computed.hasTimeWindow && computed.isNotAvailable"
         class="flex br-body-2 not-available-text">
      <span translate>Not Available</span>
    </div>
    <div *ngIf="!computed.hasTimeWindow && !computed.isNotAvailable"
         class="flex br-body-2 no-time-window">
      <span translate>No Time window</span>
    </div>
    <bringoz-button *ngIf="(computed.isAvailable || computed.hasMultipleInSameProject) && !computed.hasNoProjectRecord"
                    type="tertiary"
                    theme="primary"
                    (onClick)="onEditAvailability($event)">
      <bringoz-icon iconName="edit" classSize="lg"></bringoz-icon>
    </bringoz-button>
  </div>

  <!-- Branches -->
  <div *ngIf="resources?.length && !computed.isOnAnotherProjectOnly && !computed.hasMixedConflictState" class="layout-row layout-align-start-center info-row">
    <branches-indicator [branches]="computed.combinedBranchReferences"
                        [openInNewTab]="true"></branches-indicator>
  </div>

  <span class="flex"></span>

  <!-- Status Indicators -->
  <div *ngIf="!computed.isOnAnotherProjectOnly && !computed.hasMixedConflictState" class="layout-row status-indicators margin-top-5 info-row">
    <span class="br-body-2 status-available"
          [ngClass]="{
            'blue-pill': (computed.hasTimeWindow || computed.isNotAvailable) && computed.isFirstResourceAvailable,
            'gray-text': (!computed.hasTimeWindow && !computed.isNotAvailable) || ((computed.hasTimeWindow || computed.isNotAvailable) && !computed.isFirstResourceAvailable),
            'disabled': computed.isEditDisabled
          }"
          (click)="onAvailableClick($event)"
          [style.cursor]="computed.isEditDisabled ? 'not-allowed' : 'pointer'">
      <span translate>Available</span>
    </span>
    <span class="br-body-2 status-unavailable margin-left-10"
          [ngClass]="{
            'red-pill': (computed.hasTimeWindow || computed.isNotAvailable) && !computed.isFirstResourceAvailable,
            'gray-text': (!computed.hasTimeWindow && !computed.isNotAvailable) || ((computed.hasTimeWindow || computed.isNotAvailable) && computed.isFirstResourceAvailable),
            'disabled': computed.isEditDisabled || computed.hasNoProjectRecord || (!computed.isFirstResourceAvailable && (computed.hasTimeWindow || computed.isNotAvailable))
          }"
          (click)="onUnavailableClick($event)"
          [style.cursor]="computed.isEditDisabled || computed.hasNoProjectRecord || (!computed.isFirstResourceAvailable && (computed.hasTimeWindow || computed.isNotAvailable)) ? 'not-allowed' : 'pointer'">
      <span translate>Unavailable</span>
    </span>
  </div>
</div>

